export const getAll = (auth) => {
  const url = `/manifests`;
  return auth.fetch(url, { method: 'GET' });
}

export const create = (auth, manifest) => {
  const url = `/manifests`;
  return auth.fetch(url, { method: 'POST', body: JSON.stringify(manifest)});
}

export const addStops = (auth, manifestId, stops) => {
  const url = `/manifests/${manifestId}/stop`;
  const promises = stops.map((item) => auth.fetch(url, { method: 'POST', body: JSON.stringify(item)}));
  return Promise.all(promises);
}

export const deleteManifest = (auth, manifestId) => {
  const url = `/manifests/${manifestId}`;
  return auth.fetch(url, { method: 'DELETE' });
}

export default getAll;



// WEBPACK FOOTER //
// ./src/services/ManifestService.js